import { Report } from '@bugsnag/core';
import { SlateJsProxy } from '~/composer/composer/entities/EditorStateProxy';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';

export const updateSlateErrorData =
  ({ context, editor }: { context: string; editor: BufferEditor }) =>
  (report: Report): void => {
    const [firstTrace] = report.stacktrace;
    report.context = context;
    report.groupingHash = `${context}/${firstTrace?.method || 'unknownMethod'}`;
    report.updateMetaData('editor', {
      id: editor?.id ?? 'No id found',
      children: editor?.children ?? 'No children found on editor',
      isSlateEditor: SlateJsProxy.isEditorOrState(editor),
    });
  };
